import CodeBlock from './CodeBlock.svelte';

import { $view, $prose } from '@milkdown/utils';
import { Plugin } from '@milkdown/prose/state';
import { DecorationSet } from '@milkdown/prose/view';
import { codeBlockSchema, imageSchema } from '@milkdown/preset-commonmark';
import type { useNodeViewFactory, useWidgetViewFactory } from '@prosemirror-adapter/svelte';
import Image from './Image.svelte';

export const components = (
  viewFactory: ReturnType<typeof useNodeViewFactory>,
  widgetFactory: ReturnType<typeof useWidgetViewFactory>,
) => {
  return [
    $view(codeBlockSchema.node, () =>
      viewFactory({
        component: CodeBlock,
      }),
    ),
    $view(imageSchema.node, () =>
      viewFactory({
        component: Image,
        as() {
          const div = document.createElement('div');
          div.style.display = 'inline-block';
          return div;
        },
      }),
    ),
    // TODO: 実装する
    // $prose(() => new Plugin({
    //   state: {
    //     init: () => DecorationSet.empty,
    //     apply(tr) {}
    //   },
    //   props: {
    //     decorations(state) {
    //       return this.getState(state);
    //     },
    //   }
    // })),
  ];
};
